import BenefitGroups from "../../components/benefits-groups";

export default BenefitGroups;